import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Icons } from 'helpers/icons'

interface StoryProps {
    img?: string
    status?: string | null
    text: string
    viewed?: boolean
    type: string
}

export const StoryCircle = ({ img, text, viewed, type, status= null }: StoryProps) => {
    const { t } = useTranslation()

    if (type === 'story') {
        return (
            <StoryContainerWithImg>
                <StoryWrapper $viewed={viewed}>
                    {img && status === 'finished' ? (
                        <StoryImgCrop>
                            <StoryImg src={img} alt={t('storyImg')} />
                        </StoryImgCrop>
                    ) : (
                        <span className='processingFileLoader'></span>
                    )}
                </StoryWrapper>
                <StoryText>{text}</StoryText>
            </StoryContainerWithImg>
        )
    } else {
        return (
            <StoryContainer>
                <StoryWrapperAdd>
                    <StoryImgAdd src={Icons.plus} alt={t('addStory')} />
                </StoryWrapperAdd>
                <StoryText>{text}</StoryText>
            </StoryContainer>
        )
    }
}

const StoryContainer = styled.div`
    min-width: 5.8rem;
    height: 7.5rem;
    text-align: center;
    overflow: hidden;

`
const StoryContainerWithImg = styled(StoryContainer)`
    margin-right: 1rem;
`
const StoryWrapper = styled.div<{ $viewed?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.8rem;
    height: 5.8rem;
    overflow: hidden;
    border-radius: 50%;
    border: 0.2rem solid #2e97fe;

    ${({ $viewed }) =>
        $viewed ? 'border: 0.2rem solid rgba(232, 232, 232, 1);' : ''}
`
const StoryWrapperAdd = styled(StoryWrapper)`
    border: 0.2rem dashed #75757680;
`
const StoryImgCrop = styled.div`
    height: 5rem;
    width: 5rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
`;

const StoryImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transform: scale(1.2);
`;

const StoryImgAdd = styled.img`
    height: 1.2rem;
    width: 1.2rem;
`

const StoryText = styled.p`
    font-family: $montserrat;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.02em;
    font-weight: normal;
    font-size: 1rem;
    margin: 0.5rem 0 0 0;
    color: $grey;
    text-decoration: none;
`
